import { alpha } from '@mui/material/styles';

// SETUP COLORS
// Color Primitives
export const grey = {
    0: '#667085', //added
    100: alpha('#060618', 0.5), //added
    200: '#A0A0A0', //added
    300: '#E3E3E3', //added
    400: '#bdbdbd', //added
    500: alpha('#000000', 0.7), //added
    600: alpha('#000000', 0.8), //added
    700: '#5A5A5A', //added
    800: '#212B36', //added
    900: '#161C24', //added
    1000: '#9B9BA3', //added
    1100: '#344054', //added
    1200: '#E6E6E6', //added
};
export const gray = {
    100: '#FAFAFA',
    200: '#F3F3F3',
    300: '#E3E3E3',
    400: '#CDCDCD',
    500: '#B2B2B2',
    600: '#949494',
    700: '#767676',
    800: '#5A5A5A',
    900: '#434343',
    1000: '#303030',
};
export const brandPrimary = {
    50: '#F0F5FF',
    100: '#E1EBFF',
    200: '#BDD3FF',
    300: '#94B8FF',
    400: '#6296FE',
    500: '#0156FC',
    600: '#014DE5',
    700: '#0143C6',
    800: '#01359D',
    900: '#00297A',
    1000: '#001642',
};
export const brandSecondary = {
    50: '#F0FCFF',
    100: '#DBF8FF',
    200: '#B8F2FF',
    300: '#8AE9FF',
    400: '#52DFFF',
    500: '#00D0FF',
    600: '#00BBE6',
    700: '#00A7CC',
    800: '#0089A8',
    900: '#006075',
    1000: '#004757',
};
export const black = {
    0: alpha('#000000', 0),
    50: alpha('#000000', 0.025),
    100: alpha('#000000', 0.05),
    200: alpha('#000000', 0.1),
    300: alpha('#000000', 0.15),
    400: alpha('#000000', 0.3),
    500: alpha('#000000', 0.45),
    600: alpha('#000000', 0.6),
    700: alpha('#000000', 0.75),
    800: alpha('#000000', 0.9),
    900: alpha('#000000', 0.95),
    1000: alpha('#000000', 1),
};
export const white = {
    0: alpha('#FFFFFF', 0),
    50: alpha('#FFFFFF', 0.025),
    100: alpha('#FFFFFF', 0.05),
    200: alpha('#FFFFFF', 0.1),
    300: alpha('#FFFFFF', 0.15),
    400: alpha('#FFFFFF', 0.3),
    500: alpha('#FFFFFF', 0.45),
    600: alpha('#FFFFFF', 0.6),
    700: alpha('#FFFFFF', 0.75),
    800: alpha('#FFFFFF', 0.9),
    900: alpha('#FFFFFF', 0.95),
    1000: alpha('#FFFFFF', 1),
};


// MUI setup colors
export const primary = {
    // main: '#1FAFE5',
    main: brandPrimary[500],
    // light: "",
    // dark: "",
    // contrastText: "",
};

export const secondary = {
    main: '#060618',
    // light: "",
    // dark: "",
    // contrastText: "",
};

export const info = {
    // light: '#61F3F3',
    main: '#0089A8',
    // dark: '#006C9C',
    // contrastText: '#FFFFFF',
};

export const success = {
    light: '#D7F7C2',
    main: '#009951',
    dark: '#006908',
    // contrastText: "#FFFFFF",
};

export const warning = {
    // light: "",
    main: '#BF6A02',
    // dark: "",
    // contrastText: grey[800],
};

export const error = {
    // lighter: '#FA7979',
    light: '#FF8C44',
    main: '#C00F0C',
    // dark: "",
    // contrastText: "",
};

export const text = {
    primary: '#00297A',
    secondary: '#434343',
    disabled: black[400],

    tertiary:gray[600],
    neutralSecondary: gray[700],
    inverse: white[1000],
    statusWarning:"#BF6A02",
};

export const common = {
    black: '#000000',
    white: '#FFFFFF',
    grey: '#DBDBDB',
    red: '#FF8C44',
    darkCharcoal: '#303030',
    pacificBlue: '#0B91C4',
    slateGray: '#6A7383',
    pastelBlue: '#B8C0CC',
};

export const background = {
    default: '#FFFFFF',
    paper: '#FFFFFF',

    blue: '#CCE9FF',
    green: '#C7FDD9',
    orange: '#ffe4cc',
    red: '#ffcccc',
    neutralPrimary: '#001642', //1
    neutralSecondary: '#FAFAFA', //4
    transparent: 'transparent',
    none: 'none',
};

export const border = {
    neutralPrimary:black[200],// 1
    neutralSecondary: '#E5A000', // status suggested
    brandPrimary:"#0156FC"//1
};

export const action = {
    hover: alpha(grey[500], 0.08),
    selected: alpha(grey[500], 0.16),
    disabled: alpha(grey[500], 0.8),
    disabledBackground: alpha(grey[500], 0.24),
    focus: alpha(grey[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
    active:brandPrimary[500]
};

export const icon = {
    brandPrimary: '#01359D',
    brandTertiary:"#FF6F61",
    neutralSecondary: gray[600],
    neutralTertiary: '#B2B2B2',
};

const lightThemeBase = {
    primary,
    secondary,
    text,
    info,
    background,
    success,
    warning,
    error,
    border,
    common,
    icon,
    brandPrimary,
    brandSecondary,
    grey,
    black,
    white,
    gray,
    divider: alpha('rgba(0, 0, 0)', 0.10),
    action,
};

export default lightThemeBase;
